import { render } from "./LabWorksList.vue?vue&type=template&id=34daf6ba&scoped=true"
import script from "./LabWorksList.vue?vue&type=script&lang=js"
export * from "./LabWorksList.vue?vue&type=script&lang=js"

import "./LabWorksList.vue?vue&type=style&index=0&id=34daf6ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34daf6ba"]])

export default __exports__